import React, { Component } from "react";
import PropTypes from "prop-types";
import classnames from "classnames";

import style from "./style.css";

export default class Button extends Component {
  state = {
    disabled: false,
  };

  constructor(data) {
    super(data);
    this.state.disabled = this.props.disabled;
  }

  setEnabled() {
    this.setState({ disabled: false });
  }

  setDisabled() {
    this.setState({ disabled: true });
  }

  onClick() {
    this.props.onClick && this.props.onClick();
  }

  render() {
    const { rootClassname } = this.props;
    const finalRootClass = classnames(style.root, rootClassname);
    return (
      <button className={finalRootClass} onClick={this.onClick.bind(this)} disabled={this.state.disabled}>
        {this.props.children}
      </button>
    );
  }
}

Button.propTypes = {
  onClick: PropTypes.func.isRequired,
  rootClassname: PropTypes.string,
  disabled: PropTypes.bool,
};

Button.defaultProps = {
  disabled: false,
};



// WEBPACK FOOTER //
// ./src/components/Button/index.js